import ComplexSystem from "./ComplexSystem"

export default ComplexSystem